export default __webpack_public_path__ + "static/media/firework.c113d5e5.mp4";